import React, { useEffect, useRef, useState } from "react"
import { AssetMap, Round, TimestampedTeamRoundPlayerScoreMap } from "../types"
import calculateScores from "../scoreCalculator"
import { getSharedPusher } from "../../lib/sharedPusher"
import NetworkLeaderboardTabs from "../NetworkLeaderboardTabs"
import TeamLeaderboard from "./TeamLeaderboard"
import IndividualLeaderboard from "./IndividualLeaderboard"

interface LeaderboardScreenProps {
  round: Round
  scores: TimestampedTeamRoundPlayerScoreMap
  assets: AssetMap
}

export default function LeaderboardScreen(props: LeaderboardScreenProps) {
  const { round, assets } = props
  const [timestampedScores, setTimestampedScores] = useState(props.scores)
  const { scores, lastUpdated } = timestampedScores
  const { teamRounds, skins } = calculateScores(round, scores)
  const lastUpdatedRef = useRef(lastUpdated)
  lastUpdatedRef.current = lastUpdated

  useEffect(() => {
    if (!assets.pusherKey) {
      console.warn("pusherKey not set, no pusher updated will be received")
      return
    }
    const pusher = getSharedPusher(assets.pusherKey)
    if (!pusher) return
    const channelName = `round-${round.id}-scores`
    const channel = pusher.subscribe(channelName)
    const onUpdate = (incoming) => {
      if (incoming.lastUpdated > lastUpdatedRef.current) {
        setTimestampedScores(incoming)
      } else {
        console.log(`Ignored scores with timestamp ${incoming.lastUpdated} because latest scores are from ${lastUpdatedRef.current}`)
      }
    }
    channel.bind("update", onUpdate)
    console.log("connected to pusher")
    return () => {
      channel.unbind("update", onUpdate)
      pusher.unsubscribe(channelName)
    }
  }, [])

  return (
    <React.StrictMode>
      <section className="heading">
        <h1>{round.league.name}</h1>
        <p>
          {round.course.name}, {round.course.city}, {round.course.state}
          <br />
          {round.startDay} at {round.startTimeOfDay}
        </p>
      </section>

      <NetworkLeaderboardTabs round={round}>
        <h2>Teams</h2>
        <TeamLeaderboard round={round} teamRounds={teamRounds} />
        <h2>Individuals</h2>
        <IndividualLeaderboard round={round} teamRounds={teamRounds} />
      </NetworkLeaderboardTabs>
    </React.StrictMode>
  )
}
